import type { PropsWithAs } from "../as";
import { forwardRefWithAs } from "../as";
import type { TextProps } from "../Text/Text";
import { Text } from "../Text/Text";

/**
 * @beta
 */
export type LabelTextProps = Omit<TextProps, "lineHeight" | "fontSize" | "color" | "fontWeight">;

/**
 * @beta
 */
export const LabelText = forwardRefWithAs<LabelTextProps, "span">(function Label(
  props: PropsWithAs<LabelTextProps, "span">,
  ref: React.Ref<HTMLSpanElement>
) {
  return (
    <Text
      {...props}
      color="labelColor"
      fontSize="textBase"
      lineHeight="labelLineHeight"
      fontWeight="labelFontWeight"
      ref={ref}
    />
  );
});
